import { buildSandboxedSrcDoc } from '@littlebird/canvas';
import { useMemo, useRef } from 'react';

import { Iframe } from '@/components/ui/Iframe';

import {
  SPRITE_BASE_STYLES,
  SPRITE_EXTERNAL_LINK_SCRIPT,
} from './sprite-srcdoc';
import { useSpriteExternalLinks } from './use-sprite-external-links';

interface SpriteFrameProps {
  html: string;
  title: string;
  className?: string;
}

/**
 * Sandboxed iframe for agent/user HTML. `sandbox="allow-scripts"` (no allow-same-origin) gives
 * an opaque origin with no access to the app, cookies, or storage, and the injected CSP blocks
 * all network egress (see buildSandboxedSrcDoc). The HTML renders statically — the only host
 * bridge is the postMessage channel that forwards hyperlink clicks so they can open in the
 * system browser.
 */
export const SpriteFrame = ({ html, title, className }: SpriteFrameProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const srcDoc = useMemo(
    () =>
      buildSandboxedSrcDoc(html, {
        headScript: SPRITE_EXTERNAL_LINK_SCRIPT,
        headStyle: SPRITE_BASE_STYLES,
      }),
    [html]
  );
  useSpriteExternalLinks(iframeRef);

  return (
    <Iframe
      ref={iframeRef}
      title={title}
      srcDoc={srcDoc}
      sandbox="allow-scripts"
      className={className}
    />
  );
};
